(() => {
  const main = document.querySelector('#MainContent');
  if (!main) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const isHome = (main.dataset.template || '').includes('index');
  if (isHome) document.body.classList.add('ifl-is-home');

  requestAnimationFrame(() => document.documentElement.classList.add('ifl-ready'));

  const onScrollState = () => {
    document.body.classList.toggle('ifl-scrolled', window.scrollY > 28);
  };
  onScrollState();
  window.addEventListener('scroll', onScrollState, { passive: true });

  const revealNodes = document.querySelectorAll('.ifl-reveal');
  if ('IntersectionObserver' in window && !reduceMotion) {
    const revealObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    revealNodes.forEach((node) => revealObserver.observe(node));
  } else {
    revealNodes.forEach((node) => node.classList.add('is-visible'));
  }

  const scenes = document.querySelectorAll('[data-ifl-scene]');
  const current = document.querySelector('[data-ifl-scene-current]');
  if (scenes.length && 'IntersectionObserver' in window && !reduceMotion) {
    const sceneObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        scenes.forEach((scene) => scene.classList.remove('is-active'));
        entry.target.classList.add('is-active');
        if (current) current.textContent = entry.target.dataset.index || '01';
      });
    }, { threshold: 0.5 });
    scenes.forEach((scene) => sceneObserver.observe(scene));
  } else {
    scenes.forEach((scene) => scene.classList.add('is-active'));
  }

  const hero = document.querySelector('[data-ifl-hero]');
  const heroImage = hero && hero.querySelector('.ifl-hero__image');
  const heroContent = hero && hero.querySelector('.ifl-hero__content');

  if (hero && heroImage && !reduceMotion) {
    let ticking = false;
    const updateHeroMotion = () => {
      const rect = hero.getBoundingClientRect();
      const progress = Math.min(1, Math.max(0, -rect.top / Math.max(1, rect.height)));
      heroImage.style.transform = 'scale(' + (1 + progress * 0.045) + ') translateY(' + (progress * 24) + 'px)';
      if (heroContent) heroContent.style.transform = 'translateY(' + (progress * -14) + 'px)';
      ticking = false;
    };
    const queueHeroMotion = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(updateHeroMotion);
    };
    updateHeroMotion();
    window.addEventListener('scroll', queueHeroMotion, { passive: true });

    if (window.matchMedia('(hover:hover) and (pointer:fine)').matches) {
      hero.addEventListener('pointermove', (event) => {
        const rect = hero.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width - .5;
        const y = (event.clientY - rect.top) / rect.height - .5;
        hero.style.setProperty('--ifl-pointer-x', (x * 8) + 'px');
        hero.style.setProperty('--ifl-pointer-y', (y * 6) + 'px');
      });
      hero.addEventListener('pointerleave', () => {
        hero.style.removeProperty('--ifl-pointer-x');
        hero.style.removeProperty('--ifl-pointer-y');
      });
    }
  }
})();